import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center flex-wrap"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressRotate',
  props: {
    score: { default: 0 },
    value: { default: 0 },
    color: { default: '' },
    width: { default: 0 },
    size: { default: 0 },
    rotate: { default: 0 },
    textSize: { default: 'large' },
    showLable: { type: Boolean, default: true },
    mirror: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(_component_v_progress_circular, {
    rotate: __props.rotate,
    size: __props.size,
    width: __props.width,
    "model-value": __props.value,
    color: __props.color,
    class: _normalizeClass({ 'progress-rotate': !__props.mirror, 'progress-rotate progress-mirror': __props.mirror })
  }, {
    default: _withCtx(() => [
      (__props.showLable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", {
              class: _normalizeClass({
          'text-center title-small m-0': __props.textSize !== 'large',
          'text-center title m-0': __props.textSize === 'large'
        })
            }, [
              _createTextVNode(_toDisplayString(__props.score), 1 /* TEXT */),
              _createElementVNode("span", {
                class: _normalizeClass({
            'text-center caption-small m-0': __props.textSize !== 'large',
            'text-center caption m-0': __props.textSize === 'large'
          })
              }, "%", 2 /* CLASS */)
            ], 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["rotate", "size", "width", "model-value", "color", "class"]))
}
}

})